(function(){
  if (window.__sgInit) return; window.__sgInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function pad(n){return (n<10?'0':'')+n;}
  function money(cents, fmt){
    fmt = fmt || (window.sgMoneyFormat) || '£{{amount}}';
    var v = (cents/100);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-GB');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      return v.toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2});
    });
  }
  window.sgMoney = money;

  /* Countdown */
  function tickAll(){
    document.querySelectorAll('[data-sg-countdown]').forEach(function(el){
      var t = new Date(el.getAttribute('data-sg-countdown')).getTime();
      var diff = Math.max(0, t - Date.now());
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      if (d) d.textContent = Math.floor(diff/86400000) + 'd';
      if (h) h.textContent = pad(Math.floor(diff/3600000)%24) + 'h';
      if (m) m.textContent = pad(Math.floor(diff/60000)%60) + 'm';
      if (s) s.textContent = pad(Math.floor(diff/1000)%60) + 's';
      if (diff === 0 && el.hasAttribute('data-sg-hide-on-end')) el.hidden = true;
    });
  }
  tickAll(); setInterval(tickAll, 1000);

  /* Toast */
  var toast;
  function showToast(title, img){
    if (!toast){
      toast = document.createElement('div'); toast.className = 'sg-toast'; toast.setAttribute('role','status'); toast.setAttribute('aria-live','polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    if (img){ var i = document.createElement('img'); i.src = img; i.alt = ''; toast.appendChild(i); }
    var p = document.createElement('p'); p.textContent = title; toast.appendChild(p);
    var a = document.createElement('a'); a.href = root + 'checkout'; a.textContent = 'Checkout →'; toast.appendChild(a);
    requestAnimationFrame(function(){ toast.classList.add('is-on'); });
    clearTimeout(toast._t); toast._t = setTimeout(function(){ toast.classList.remove('is-on'); }, 4200);
  }

  /* Add to cart */
  function sgAdd(items, btn, label, img){
    if (btn){ btn.classList.add('is-loading'); btn.setAttribute('aria-busy','true'); }
    return fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){ return fetch(root + 'cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        var ev = new CustomEvent('cart:update', {bubbles:true, detail:{resource:cart, sourceId:'sg-premium', data:{source:'sg-premium', itemCount:cart.item_count}}});
        document.dispatchEvent(ev);
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function'){ setTimeout(function(){ try{ drawer.open(); }catch(e){ showToast(label || 'Added to your cart', img); } }, 250); }
        else { showToast(label || 'Added to your cart', img); }
      })
      .catch(function(err){
        var msg = (err && (err.description || err.message)) || 'Sorry, that item could not be added.';
        showToast(msg);
      })
      .finally(function(){ if (btn){ btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }
  window.sgAdd = sgAdd;

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-sg-add]');
    if (b){
      e.preventDefault();
      var id = b.getAttribute('data-sg-add');
      var scope = b.closest('[data-sg-product]');
      var sel = scope && scope.querySelector('[data-sg-variant]');
      if (sel && sel.value) id = sel.value;
      sgAdd([{id: parseInt(id,10), quantity: 1}], b, (b.getAttribute('data-title') || 'Item') + ' added', b.getAttribute('data-img'));
      return;
    }
    /* Tabs */
    var t = e.target.closest('[data-sg-tab]');
    if (t){
      var wrap = t.closest('[data-sg-tabs]');
      wrap.querySelectorAll('[data-sg-tab]').forEach(function(x){ x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      wrap.querySelectorAll('[data-sg-panel]').forEach(function(p){ p.hidden = p.getAttribute('data-sg-panel') !== t.getAttribute('data-sg-tab'); });
      return;
    }
    /* Gift finder */
    var o = e.target.closest('[data-sg-opt]');
    if (o){
      var f = o.closest('[data-sg-finder]');
      var g = o.closest('[data-sg-q]');
      g.querySelectorAll('[data-sg-opt]').forEach(function(x){ x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
      f.dataset[g.getAttribute('data-sg-q')] = o.getAttribute('data-sg-opt');
      var budget = f.dataset.budget, vibe = f.dataset.vibe, who = f.dataset.who;
      var results = f.querySelectorAll('[data-sg-result]');
      var hint = f.querySelector('[data-sg-hint]');
      if (!(budget && vibe && who)) return;
      var best = null, bestScore = -1;
      results.forEach(function(r){
        var sc = 0;
        if (r.getAttribute('data-budget') === budget) sc += 4;
        if (r.getAttribute('data-vibe') === vibe) sc += 2;
        if ((r.getAttribute('data-who') || '').split(',').indexOf(who) > -1) sc += 1;
        if (sc > bestScore){ bestScore = sc; best = r; }
      });
      results.forEach(function(r){ r.hidden = r !== best; });
      if (hint) hint.hidden = true;
      return;
    }
    /* Bundle */
    var pk = e.target.closest('[data-sg-pick]');
    if (pk){
      var bw = pk.closest('[data-sg-bundle]');
      var max = parseInt(bw.getAttribute('data-max') || '3', 10);
      var on = pk.getAttribute('aria-pressed') === 'true';
      var count = bw.querySelectorAll('[data-sg-pick][aria-pressed=true]').length;
      if (!on && count >= max) return;
      pk.setAttribute('aria-pressed', on ? 'false' : 'true');
      pk.querySelector('.sg-chk').textContent = on ? '+' : '✓';
      updateBundle(bw);
      return;
    }
    var ba = e.target.closest('[data-sg-bundle-add]');
    if (ba){
      var bw2 = ba.closest('[data-sg-bundle]');
      var items = [];
      bw2.querySelectorAll('[data-sg-pick][aria-pressed=true]').forEach(function(p){ items.push({id: parseInt(p.getAttribute('data-variant'),10), quantity:1}); });
      if (items.length) sgAdd(items, ba, 'Your Glow Set is in the cart');
    }
  });

  function updateBundle(bw){
    var max = parseInt(bw.getAttribute('data-max') || '3', 10);
    var pct = parseFloat(bw.getAttribute('data-pct') || '10');
    var picked = bw.querySelectorAll('[data-sg-pick][aria-pressed=true]');
    var sum = 0; var imgs = [];
    picked.forEach(function(p){ sum += parseInt(p.getAttribute('data-price'),10); imgs.push(p.querySelector('img') ? p.querySelector('img').src : ''); });
    var slots = bw.querySelectorAll('.sg-slot');
    slots.forEach(function(s, i){
      s.innerHTML = '';
      if (imgs[i]){ s.classList.add('is-on'); var im = document.createElement('img'); im.src = imgs[i]; im.alt = ''; s.appendChild(im); }
      else { s.classList.remove('is-on'); s.textContent = String(i+1); }
    });
    var left = max - picked.length;
    var msg = bw.querySelector('[data-sg-bmsg]');
    if (msg) msg.textContent = left > 0 ? ('Choose ' + left + ' more to unlock ' + pct + '% off') : ('Set complete — ' + pct + '% off applied at checkout');
    var was = bw.querySelector('[data-sg-bwas]'), now = bw.querySelector('[data-sg-bnow]');
    if (was) was.textContent = picked.length === max ? money(sum) : '';
    if (now) now.textContent = money(picked.length === max ? Math.round(sum * (1 - pct/100)) : sum);
    var add = bw.querySelector('[data-sg-bundle-add]');
    if (add) add.disabled = picked.length !== max;
  }
})();
